import React, { useState } from 'react';
import '../css/EventCalendar.css';

const EventCalendar = ({ events = [], onEventClick, onEmptyDateClick }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  
  // Sample events data - you can replace this with data from your API
  const sampleEvents = [
    {
      id: 1,
      title: "Exodia Victory Party",
      date: "2025-09-20",
      time: "7:00 PM",
      location: "Boracay Island, Philippines",
      description: "Join us for an epic celebration of our victories and achievements!",
      type: "celebration"
    },
    {
      id: 2,
      title: "Team Building Workshop",
      date: "2025-08-15",
      time: "10:00 AM",
      location: "Virtual Meeting",
      description: "Enhance team collaboration and communication skills.",
      type: "workshop"
    },
    {
      id: 3,
      title: "Product Launch Event",
      date: "2025-10-05",
      time: "2:00 PM",
      location: "Main Office",
      description: "Launch of our latest product features and updates.",
      type: "launch"
    }
  ];

  // Combine sample events with passed events
  const allEvents = [...sampleEvents, ...events];

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();
    
    const days = [];
    
    // Add empty cells for days before the first day of the month
    for (let i = 0; i < startingDayOfWeek; i++) {
      days.push(null);
    }
    
    // Add days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(new Date(year, month, day));
    }
    
    return days;
  };

  const getEventsForDate = (date) => {
    if (!date) return [];
    const dateStr = date.toISOString().split('T')[0];
    return allEvents.filter(event => event.date === dateStr);
  };

  const navigateMonth = (direction) => {
    setCurrentDate(prevDate => {
      const newDate = new Date(prevDate);
      newDate.setMonth(prevDate.getMonth() + direction);
      return newDate;
    });
  };

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const days = getDaysInMonth(currentDate);
  const today = new Date();
  const isToday = (date) => {
    if (!date) return false;
    return date.toDateString() === today.toDateString();
  };

  const isCurrentMonth = (date) => {
    if (!date) return false;
    return date.getMonth() === currentDate.getMonth();
  };

  return (
    <div className="gamified-calendar">
      <div className="calendar-header">
        <button className="nav-button" onClick={() => navigateMonth(-1)}>
          <span className="nav-icon">◀</span>
        </button>
        <div className="calendar-title-container">
          <h3 className="calendar-title">
            {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
          </h3>
          <div className="calendar-subtitle">Event Calendar</div>
        </div>
        <button className="nav-button" onClick={() => navigateMonth(1)}>
          <span className="nav-icon">▶</span>
        </button>
      </div>

      <div className="calendar-grid">
        <div className="calendar-weekdays">
          {dayNames.map(day => (
            <div key={day} className="weekday-header">
              <span className="weekday-text">{day}</span>
            </div>
          ))}
        </div>
        
        <div className="calendar-days">
          {days.map((date, index) => {
            const eventsForDate = getEventsForDate(date);
            const hasEvents = eventsForDate.length > 0;
            
            return (
              <div
                key={index}
                className={`calendar-day ${!isCurrentMonth(date) ? 'other-month' : ''} ${isToday(date) ? 'today' : ''} ${hasEvents ? 'has-events' : ''}`}
                onClick={() => {
                  if (hasEvents && onEventClick) {
                    onEventClick(eventsForDate, date);
                  } else if (!hasEvents && onEmptyDateClick) {
                    onEmptyDateClick(date);
                  }
                }}
              >
                {date && (
                  <>
                    <div className="day-content">
                      <span className="day-number">{date.getDate()}</span>
                      {hasEvents && (
                        <div className="event-indicators">
                          {eventsForDate.slice(0, 2).map((event, eventIndex) => (
                            <div
                              key={eventIndex}
                              className={`event-dot event-dot-${event.type}`}
                              title={event.title}
                            />
                          ))}
                          {eventsForDate.length > 2 && (
                            <div className="event-dot event-dot-more">
                              +{eventsForDate.length - 2}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    {hasEvents && (
                      <div className="event-glow"></div>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
      
      <div className="calendar-footer">
        <div className="event-legend">
          <div className="legend-item">
            <div className="legend-dot event-dot-celebration"></div>
            <span>Celebration</span>
          </div>
          <div className="legend-item">
            <div className="legend-dot event-dot-workshop"></div>
            <span>Workshop</span>
          </div>
          <div className="legend-item">
            <div className="legend-dot event-dot-launch"></div>
            <span>Launch</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCalendar;
